import ButtonV2 from "./button";

export default ButtonV2;
